/**
 * Anchor wrapper that applies nofollow / noopener / noreferrer on external links.
 */

import React from "react";
import PropTypes from "prop-types";
import {getExternalLinkProps} from "helpers/linkUtils";

const propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string
};

const defaultProps = {
  children: null,
  href: undefined,
  rel: undefined,
  target: undefined
};

const SafeLink = ({children, href, rel, target, ...rest}) => (
  <a {...getExternalLinkProps(href, {rel, target, ...rest})}>
    {children}
  </a>
);

SafeLink.propTypes = propTypes;
SafeLink.defaultProps = defaultProps;

export default SafeLink;
